import { hexToHsva, hsvaToHex } from '@uiw/color-convert'
import ColorPicker from '@/shared/components/ColorPicker/ColorPicker'
import { useScheduleStore } from '../../store/useScheduleStore'
import styles from './EmployeeColorPicker.module.scss'

interface EmployeeColorPickerProps {
  userId: string
  /** Current colour as hex, either the override or the default slot */
  color: string
  name: string
  /** Weekly total, shown under the name */
  hoursLabel: string
}

/**
 * The roster's name cell: the app's shared colour-picker tile, carrying the
 * employee's name with their scheduled hours underneath and the swatch on the
 * right. The picker speaks HSVA while the store keeps hex, so the conversion
 * lives here rather than leaking a picker-specific shape into schedule state.
 */
function EmployeeColorPicker(props: EmployeeColorPickerProps) {
  const { userId, color, name, hoursLabel } = props
  const setEmployeeColor = useScheduleStore(state => state.setEmployeeColor)
  const commitEmployeeColors = useScheduleStore(
    state => state.commitEmployeeColors
  )

  return (
    <div className={styles.picker}>
      <ColorPicker
        label={
          <>
            <span className={styles.name}>{name}</span>
            <span className={styles.hours}>{hoursLabel}</span>
          </>
        }
        color={hexToHsva(color)}
        // Live, so the roster bars follow the pointer.
        setColor={next => setEmployeeColor(userId, hsvaToHex(next))}
        // The save hangs off this, not off `setColor`: a drag emits a colour
        // every 150ms and each one would otherwise be a whole-week PUT.
        onChangeCommitted={() => commitEmployeeColors()}
      />
    </div>
  )
}

export default EmployeeColorPicker
